import {
    DeleteOutlined,
    EyeOutlined, UploadOutlined
} from "@ant-design/icons";
import {
    Button,
    Col, Image, Row, Space, Upload
} from "antd";
import { useRef } from "react";
import "./index.scss";

const MenuLeft = ({ imageUrl, setFileList, setImageUrl, span = 8, setIsCheckRemoveImg = undefined }) => {
    const ref = useRef();
    const beforeUpload = (file) => {
        return false;
    };

    const handleChange = async (info) => {
        setFileList(info.file);
        const a = await getBase64(info.file);
        setImageUrl(URL.createObjectURL(info.file));
        console.log(setFileList)
    };

    const getBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            if (setIsCheckRemoveImg) {
                setIsCheckRemoveImg(false);
            }
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    };

    const openModal = () => {
        setPreviewImage(true);
    };

    const onRemoveImage = () => {
        setImageUrl("");
        setFileList("");
        if (setIsCheckRemoveImg) {
            setIsCheckRemoveImg(true);
        }
    };

    return (
        <>
            <Row>
                {/* {imageUrl && (
                    <Col span={span} className="img-setting">
                        <input
                            type="image"
                            src={
                                imageUrl ||
                                "/avatars/default.png"
                            }
                            className="image"
                            alt="avatar"
                            height={300}
                            style={{
                                width: "100%",
                                objectFit: "contain",
                            }}
                        />

                        <div className="middle">
                            <Space>
                                <Button
                                    type="ghost"
                                    shape="circle"
                                    icon={
                                        <EyeOutlined
                                            style={{
                                                color: "#ffffff",
                                            }}
                                        />
                                    }
                                    size="middle"
                                    title="Xem"
                                    onClick={openModal}
                                />
                                <Button
                                    type="ghost"
                                    shape="circle"
                                    icon={
                                        <DeleteOutlined
                                            style={{
                                                color: "#ffffff",
                                            }}
                                        />
                                    }
                                    size="middle"
                                    title="Xóa"
                                    onClick={onRemoveImage}
                                />
                            </Space>
                        </div>
                    </Col>
                )} */}
                <div className="wrapper-img-banner">
                    {imageUrl &&
                        <div className="wrap-img">
                            <div className="close-img" onClick={onRemoveImage}>
                                <img src="/icon/close_img.svg" alt="" />
                            </div>
                            <Image src={`${imageUrl}`} alt="2" />
                        </div>
                    }
                </div>
            </Row>
            <Row>
                <Upload
                    ref={ref}
                    name="image"
                    className="upload"
                    onChange={handleChange}
                    multiple={false}
                    beforeUpload={beforeUpload}
                    showUploadList={false}
                    accept="image/*"
                >
                    <Button
                        type="primary"
                        className="btn-upload"
                        icon={
                            <UploadOutlined className="icon-upload" />
                        }
                    >
                        Upload
                    </Button>
                </Upload>
            </Row>
        </>
    );
};
export default MenuLeft;
